import script from "./FeaturedContentCards.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeaturedContentCards.vue?vue&type=script&setup=true&lang=ts"

import "./FeaturedContentCards.vue?vue&type=style&index=0&id=6d2a7130&lang=scss"

const __exports__ = script;

export default __exports__